export enum SupportedLanguages {
  'nl'= 'nl',
  'en'= 'en',
  'fr' = 'fr'
}

export interface ILanguage {
  value: SupportedLanguages;
  label: string;
  short: string;
}

export function resolveSupportedLanguage(lang: string): SupportedLanguages {
  return Object.values(SupportedLanguages).includes(lang as SupportedLanguages)
    ? (lang as SupportedLanguages)
    : SupportedLanguages.fr;
}

export function getPossibleLanguages(): ILanguage[] {
  return [
    {value: SupportedLanguages.fr, label: 'Français', short: 'fr'},
    {value: SupportedLanguages.nl, label: 'Nederlands', short: 'nl'},
    {value: SupportedLanguages.en, label: 'English', short: 'en'}
  ]
}
